import { IAiChatMessage } from './types';

export const getAiChatMessageKey = (message: IAiChatMessage) => message.id ?? message.clientId;

export const uniqAiChatMessages = (messages: IAiChatMessage[]) => {
    const seenMessageKeys = new Set<string | number>();

    return messages.filter((message) => {
        const messageKey = getAiChatMessageKey(message);

        if (seenMessageKeys.has(messageKey)) {
            return false;
        }

        seenMessageKeys.add(messageKey);

        return true;
    });
};
